import React, { useEffect } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { IRange } from "../../data/Query";
import { toNumber } from "lodash";
 
interface Props {
    minTitle: string,
    maxTitle: string,
    min: number | null,
    max : number | null,
    onUpdate: (r: IRange) => void
};

const RangeCtrl = ({min, max, minTitle, maxTitle, onUpdate}: Props) => {
    const [state, setState] = React.useState({
        min: min,
        max: max,
        minInterim: min,
        maxInterim: max
    });

    useEffect(() => {
        if(state.min && state.max)
            onUpdate({...state});
    }, [state]);

    useEffect(() => {
        setState(
            {
                ...state,
                min,
                max,
                minInterim: min,
                maxInterim: max
            }
        );
    }, [min, max]);

    const handleChange = (evt: any) => {
        const value = evt.target.value;
        console.log("120723 evt", evt);
        console.log("120723 evt.target", evt.target);
        console.log("120723 value", value);
        //const re = /^[0-9\b]+$/; // does not accept decimal (e.g., 12)
        const re = /^\d+(\.\d*)?$/; // accepts decimal (e.g., 12.4 or 12. or 12)

        if (value === '' || re.test(value)) {
            setState({
                ...state,
                [evt.target.name]: toNumber(value),
                [`${evt.target.name}Interim`]: value
            });
        }
    }

    const onClear = (evt: any) => {
        evt.preventDefault();

        const reset = { 
            min: null, 
            max: null,
            minInterim: null, 
            maxInterim: null
        };

        setState(reset);

        onUpdate({...reset});
    }

    return (
        <div>
            <Form.Row>
                <Form.Group as={Col} className="mb-0">
                    <Form.Label>{minTitle}</Form.Label>
                    <Form.Control 
                        type="text" 
                        name="min"
                        value={state.min && state.minInterim
                            ? /^\d+\.$/.test(state.minInterim.toString())
                                ? `${state.minInterim}`
                                : `${state.min}` 
                            : (state.min === 0) 
                                ? `${state.min}` 
                                : ''}
                        onChange={handleChange}
                        placeholder="minimum value" />
                    <Button variant="link" className="m-0 p-0 mt-1" onClick={onClear}>clear</Button>
                </Form.Group>

                <Form.Group as={Col}>
                    <Form.Label>{maxTitle}</Form.Label>
                    <Form.Control 
                        type="text"
                        name="max"
                        value={state.max && state.maxInterim
                            ? /^\d+\.$/.test(state.maxInterim.toString())
                                ? `${state.maxInterim}`
                                : `${state.max}` 
                            : (state.max === 0) 
                                ? `${state.max}` 
                                : ''}
                        onChange={handleChange}
                        placeholder="maximum value" />
                </Form.Group>
            </Form.Row>
        </div>
    );
}

export default RangeCtrl;